import { sortAlphaBeta } from '.';
import {
  COLOR_PARCELS_BY,
  COLOR_TRACKS_BY,
  ColorChoice,
  ParcelColorChoice,
  TrackColorChoice,
} from '../constants/colorConstants';

export function sortColorChoices(a: ColorChoice, b: ColorChoice) {
  return a === 'default' ? -1 : b === 'default' ? 1 : sortAlphaBeta(a, b);
}

function colorHasLeadingHash(color: string): color is `#${string}` {
  return color.startsWith('#');
}

export function getColorWithHash(color: string): `#${string}` {
  return colorHasLeadingHash(color) ? color : `#${color}`;
}

function isColorChoice(choice: unknown): choice is ColorChoice {
  return (
    typeof choice === 'string' &&
    (Object.values(COLOR_PARCELS_BY).includes(choice) || Object.values(COLOR_TRACKS_BY).includes(choice))
  );
}

export function isParcelColorChoice(choice: ColorChoice): choice is ParcelColorChoice {
  return Object.values(COLOR_PARCELS_BY).includes(choice);
}

export function isTrackColorChoice(choice: ColorChoice): choice is TrackColorChoice {
  return Object.values(COLOR_TRACKS_BY).includes(choice);
}

export function getStoredColorChoice(localStorageKey: string): ColorChoice {
  const stored = localStorage.getItem(localStorageKey);
  return isColorChoice(stored) ? stored : 'default';
}

export function randomHexColor(): `#${string}` {
  return `#${((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0')}`;
}

export function hexToHsl(hex?: string): [number, number, number] {
  if (!hex) {
    return [0, 0, 0];
  }

  const hexWithHash = getColorWithHash(hex);

  const r = parseInt(hexWithHash.slice(1, 3), 16) / 255;
  const g = parseInt(hexWithHash.slice(3, 5), 16) / 255;
  const b = parseInt(hexWithHash.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const d = max - min;
  const l = (max + min) / 2;

  if (d === 0) return [0, 0, l];

  const s = d / (l > 0.5 ? 2 - max - min : max + min);
  const h = max === r ? ((g - b) / d + (g < b ? 6 : 0)) / 6 : max === g ? ((b - r) / d + 2) / 6 : ((r - g) / d + 4) / 6;

  return [h, s, l];
}
